/** Recognise our public handbook links, including production links on staging. */
export function handbookPath(href: string, origin = window.location.origin, base = import.meta.env.BASE_URL): string | null {
  try {
    const url = new URL(href, origin + base)
    if (url.origin !== origin && !/(^|\.)saysomethingin\.app$/.test(url.hostname)) return null
    if (!/^https?:$/.test(url.protocol)) return null
    const path = url.pathname.startsWith(base) ? '/' + url.pathname.slice(base.length) : url.pathname
    return /^\/handbook(?:\/|$)/.test(path) ? path + url.search + url.hash : null
  } catch { return null }
}
